/**
 * BillingCancel Page
 * Shown when user cancels Stripe checkout
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-8 w-8 text-amber-600" />
        </div>

        <h1 className="text-2xl font-bold text-navy-900 mb-2">
          Checkout Canceled
        </h1>
        <p className="text-navy-600 mb-6">
          No worries! Your payment was not processed. You can subscribe anytime.
        </p>

        <div className="bg-navy-50 rounded-lg p-4 mb-6">
          <p className="text-navy-700 text-sm">
            Questions about pricing or features? Feel free to explore our plans or contact us for more information.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/owner/billing')}
            className="w-full btn-primary inline-flex items-center justify-center gap-2"
          >
            <CreditCard className="h-4 w-4" />
            Try Again
          </button>

          <button
            onClick={() => navigate('/owner')}
            className="w-full btn-secondary inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default BillingCancel;
